// reducers/groupsReducer.js
import { createSlice } from "@reduxjs/toolkit";

export const groupsslice = createSlice({
  name: "groups",
  initialState: {
    groups: [],
  },
  reducers: {
    seteditedNewgroups: (state, action) => {
      // //// console.log(action.payload);
      state.groups = action.payload;
    },
    AddNewgroups: (state, action) => {
      state.groups = [...state.groups, action.payload];
    },
    AddNewngroupArray: (state, action) => {
      // Use utility function to combine and format nodes
      // state.groupss = formatAndCombineNodes(state.groupss, action.payload);
      state.groups = [...state.groups, ...action.payload];
    },
    updategroups: (state, action) => {
      let data = action.payload;
      let index = state.groups.findIndex(
        (obj) => obj._id.toString() === data._id.toString()
      );
      if (index !== -1) {
        state.groups[index] = data;
      }
    },
    deletegroup: (state, action) => {
      const id = action.payload;
      let groupdata = state.groups.filter((item) => item._id !== id);
      state.groups = groupdata;
    },
    groupLogout: (state) => {
      state.groups = [];
    },
  },
});

export const selectgroups = (state) => state.groups.groups;

export const {
  seteditedNewgroups,
  AddNewngroupArray,
  updategroups,
  deletegroup,
  AddNewgroups,
  groupLogout,
} = groupsslice.actions;
export default groupsslice.reducer;
